<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="480px"
    custom-class="UpgradeDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <img :src="$utils.getPng('web4/icon-circle-fill')" />
          <span>确定下载文件？</span>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content">
        <img :src="$utils.getPng('openvip')" class="openvip" />
      </div>
      <div class="d-footer">
        <fm-button class="btnClass" type="primary" size="small" @click="govip"
          >开通会员</fm-button
        >
        <fm-button
          class="btnClass"
          type="info"
          plain
          size="small"
          @click="WatchVideos"
          >看视频下载</fm-button
        >
        <fm-button
          class="btnClass"
          type="info"
          plain
          size="small"
          @click="ordinary"
          >普通下载</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "title",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    ordinary() {
      this.$emit("ordinary");
    },
    WatchVideos(){
        this.$emit("WatchVideos");
    },
    govip() {
      window.open("/vip");
    },
  },
};
</script>

<style lang="scss" scoped>
.UpgradeDialog {
  .title {
    margin-top: 32px;
    margin-bottom: 12px;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    span {
      color: #f67942;
    }
  }
  .txt {
    line-height: 22px;
    margin-bottom: 24px;
    text-align: center;
  }

  .d-content {
    text-align: center;
    margin: 30px 0 24px 0;
    .openvip {
      width: 416px;
      height: 142px;
    }
  }

  .d-footer {
    display: flex;
    justify-content: center;
    .btnClass {
      width: 120px;
      height: 36px;
      border-radius: 18px;
      margin-right: 20px;
      &:last-child {
        margin-left: 0px;
        margin-right: 0px;
      }
    }
  }
}
</style>